.rowText {
    display: flex;
    align-items: center;
    min-height: 40px;
}
.indentLevel0 {
    margin: 0px 0.75rem 0px 0px;
}
.indentLevel1 {
    margin: 0px 0.75rem 0px 25px;
}
.indentLevel2 {
    margin: 0px 0.75rem 0px 50px;
}
.indentLevel3 {
    margin: 0px 0.75rem 0px 75px;
}
.indentLevel4 {
    margin: 0px 0.75rem 0px 100px;
}
.indentLevel5 {
    margin: 0px 0.75rem 0px 125px;
}
.hrModifier {
    margin: 0px;
    border: 1px solid var(--hps-blue);
    opacity: 0.06;
}